<template>
    <div id="div">

      <div class="content-wrapper">
                  <div class="page-heading">
                      <div class="page-content fade-in-up">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="ibox">
                                    <div class="ibox-body projects-wrapper">
                                        <div class="row">
                                            <div class="col-md-12 mb-5">
                                                <div class="row">
                                                    <span style="padding-top: 7px;"><b>{{$t('message.selectCategoryForSorting')}}:</b></span>
                                                    <select v-model="categorySelected">
                                                        <option value="start_date">{{$t('message.startDate')}}</option>
                                                        <option value="end_date">{{$t('message.endDate')}}</option>
                                                    </select>
                                                    <button class="btn view" @click="sortSheets()"><i class="fa"
                                                                                                      v-bind:class="[isArrowDown ? 'fa-sort-asc' : 'fa-sort-desc']"></i>
                                                    </button>
                                                    <button class="btn view" @click="showRegularView = !showRegularView"><i class="fa"
                                                                                                                            v-bind:class="[showRegularView ? 'fa-list-ul' : 'fa-th-large']"></i>
                                                    </button>
                                                </div>

                                                <div v-if="showRegularView && sheets.length" class="row">
                                                    <div
                                                            v-for="(sheet, index) in sheets" :key="index"
                                                            class="col-lg-3 col-md-4 box"
                                                            :class="{projectNotActive: !sheet.project_status}">
                                                        <div :style="{'pointer-events': isSheetClosedStyles(sheet)['pointerEvents'], 'opacity': isSheetClosedStyles(sheet)['opacity']}">
                                                            <div :class="{projectNotActiveOverlay: !sheet.project_status}">
                                                                <div class="project-box-wrapper">
                                                                    <div class="image-wrapper">
                                                                        <div v-if="sheet.is_closed" style="z-index: 100; position: absolute; color: black">
                                                                            <div class="col-md-12 mt-5 text-center">
                                                                                <div><h2>{{$t('message.closedByAdministrator')}}</h2>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <router-link v-if="sheet.status"
                                                                                    :to="{name: 'ActualCostsWork', params: {id: sheet.id, type: 'personnel', heading: 'work', lastRoute: 'Dashboard'}}">
                                                                            <img style="object-fit: cover; height: 100%; width: 100%;"
                                                                                :src="returnImage(sheet.project_profile_image)"
                                                                                alt="image">
                                                                        </router-link>

                                                                    </div>
                                                                    <label class="mt-2"><b>{{$t('message.projectName')}}: </b>{{sheet.project_name}}</label><br>

                                                                    <label><b>{{$t('message.status')}}:</b> <span
                                                                            v-if="sheet.project_status">{{$t('message.active')}} <button
                                                                            style="height: 12px; width: 12px"
                                                                            class="btn btn-sm btn-success btn-circle activity-button"></button></span><span
                                                                            v-if="!sheet.project_status">{{$t('message.notActive')}} <button
                                                                            style="height: 12px; width: 12px"
                                                                            class="btn btn-sm btn-danger btn-circle activity-button"></button></span></label><br>
                                                                    <label for="" class="mt-2"><b>{{$t('message.work')}}: </b>{{sheet.job}}</label><br>

                                                                    <label class="mt-2"><b>{{$t('message.yourParticipationOnProject')}}: </b></label><br>

                                                                    <label><b>{{$t('message.startDate')}}:</b> <span
                                                                            v-if="sheet.start_date">{{sheet.start_date}}</span>
                                                                        <span v-if="!sheet.start_date">{{$t('message.noStartDate')}}</span></label><br>

                                                                    <label><b>{{$t('message.endDate')}}:</b> <span
                                                                            v-if="sheet.end_date">{{sheet.end_date}}</span><span
                                                                            v-if="!sheet.end_date">{{$t('message.noEndDate')}}</span></label><br>


                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style="width: 100%" class="text-center" v-if="sheets.length === 0">
                                                        <h1 style="color: #bfbfbf; margin-top: 3%;">
                                                            {{$t('message.noProjects')}}</h1>
                                                    </div>
                                                </div>

                                                <div v-if="!showRegularView" class="row">

                                                    <div class="col-md-12">
                                                        <table class="table table-striped">
                                                            <thead>
                                                            <tr>
                                                                <th scope="col"></th>
                                                                <th scope="col">{{$t('message.projectName')}}</th>
                                                                <th scope="col">{{$t('message.status')}}</th>
                                                                <th scope="col">{{$t('message.yourParticipationStarts')}}</th>
                                                                <th scope="col">{{$t('message.yourParticipationEnds')}}</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody v-if="sheets.length !== 0">
                                                            <tr v-for="(sheet, index) in sheets" :key="index"
                                                                :class="{projectNotActive: !sheet.project_status, projectNotActiveOverlayTable: !sheet.project_status}">
                                                                <th scope="row">{{index + 1}}</th>
                                                                <router-link :disabled="!sheet.status"
                                                                            :to="{name: 'ActualCostsWork', params: {id: sheet.id, type: 'personnel', heading: 'work'}}">
                                                                    <td scope="col">{{sheet.project_name}}</td>
                                                                </router-link>
                                                                <td scope="col"><span v-if="sheet.project_status">{{$t('message.active')}} <button
                                                                        style="height: 12px; width: 12px"
                                                                        class="btn btn-sm btn-success btn-circle activity-button"></button></span><span
                                                                        v-if="!sheet.project_status">{{$t('message.notActive')}} <button
                                                                        style="height: 12px; width: 12px"
                                                                        class="btn btn-sm btn-danger btn-circle activity-button"></button></span>
                                                                </td>
                                                                <td v-if="sheet.start_date" scope="col">{{sheet.start_date}}</td>
                                                                <td v-else scope="col">{{$t('message.noStartDate')}}</td>
                                                                <td v-if="sheet.end_date" scope="col">{{sheet.end_date}}</td>
                                                                <td v-else scope="col">{{$t('message.noEndDate')}}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    <div style="width: 100%" class="text-center" v-if="sheets.length === 0">
                                                        <h1 style="color: #bfbfbf; margin-top: 3%;">
                                                            {{$t('message.noProjects')}}</h1>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>
                  </div>
      </div>

    </div>

</template>

<script>
  export default {
    name: 'CraftsmenDashboard',
    data () {
      return {
        altImage: '/assets/noImg.jpg',
        sheets: [],
        showRegularView: true,
        isArrowDown: true,
        categorySelected: 'start_date',
        order_by: '?order_by='
      }
    },
    created () {
      this.getList(this.apiPrefix, this.sheetApiUrl)
        .then(resp => {
          this.sheets = resp.data.map(row => ({
            id: row.id,
            project_name: row.project.name,
            start_date: row.start_date,
            end_date: row.end_date,
            project_status: row.project.status,
            job: row.job.name,
            // make the correct string of incorrect input
            status: row.project.status,
            project_profile_image: row.project.profile_image,
            is_closed: row.is_closed
          }))
        })
        .catch(err => {
          console.log(err.response)
        })
    },
    methods: {
      // in case profile_image does not exist, return alternative image
      returnImage (image) {
        if (image)
          return image.image
        return this.altImage
      },
      sortSheets () {
        let order_by = ''

        this.isArrowDown = !this.isArrowDown
        if (!this.isArrowDown) {
          order_by += '-'
        }

        order_by += this.categorySelected

        this.sheets.sort(this.dynamicSort(order_by))
      },
      dynamicSort (property) {
        let sortOrder = 1
        if (property[0] === '-') {
          sortOrder = -1
          property = property.substr(1)
        }
        return function (a, b) {
          let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
          return result * sortOrder
        }
      },

      isSheetClosedStyles (sheet) {
        console.log('is sheet')
        console.log(sheet)
        if (sheet.is_closed) {
          return {
            pointerEvents: 'none',
            opacity: 0.5
          }
        }

        return {
          pointerEvents: 'auto',
          opacity: 1
        }
      }
    },
  }
</script>

<style scoped>
    .projectNotActive {
        pointer-events: none;
    }

    .projectNotActiveOverlay {
        background: rgba(128, 128, 128, 0.1);
        z-index: 1;
    }

    .projectNotActiveOverlayTable {
        background: rgba(240, 52, 52, 0.3) !important;
        z-index: 1;
    }
</style>